import { theme } from "../lib/theme";

const { bg: BG } = theme;

export default function RequestDemo() {
  return (
    <main style={{ background: BG }} className="px-4 py-12 sm:px-6">
      <div className="mb-6 mx-auto max-w-[1000px]">
        <p className="text-xs font-extrabold uppercase tracking-wide text-[#BC0319]">BOOK A DEMO</p>
        <h1 className="mt-1.5 text-[28px] font-extrabold leading-[34px] tracking-tight text-[#1F2A3A]">
          Schedule your personalized demo
        </h1>
        <p className="mt-2.5 max-w-[620px] text-sm leading-[22px] text-[#5A6472]">
          Choose a time that works for you using our booking calendar.
        </p>
      </div>

      <div className="rounded-3xl border border-[#E8E4DE] overflow-hidden bg-white">
        <iframe
          src="https://bookings.cloud.microsoft/book/Motosportsoftware@motosportsoftware.com/?ismsaljsauthenabled"
          width="100%"
          height="1950"
          scrolling="yes"
          style={{ border: "none" }}
          title="Book a demo with Motosport Software"
        />
      </div>
    </main>
  );
}
